module.exports = __webpack_public_path__ + "static/media/image_terapia_t_2.44c4b988.png";